import { useState } from 'react';

export default function SlideshowGallery({ images = [] }) {
  const [slideIndex, setSlideIndex] = useState(0);

  if (!images.length) return null;

  const nextSlide = (n) => {
    const newIndex = (slideIndex + n + images.length) % images.length;
    setSlideIndex(newIndex);
  };

  const selectSlide = (n) => {
    setSlideIndex(n);
  };

  return (
    <div className="font-sans">
      {/* Main container: column on mobile, row on desktop */}
      <div className="flex flex-col-reverse md:flex-row gap-4">
        {/* Thumbnails */}
        <div className="flex flex-row md:flex-col gap-2 md:w-24 w-full overflow-x-auto md:overflow-visible">
          {images.map((img, idx) => (
            <img
              key={idx}
              src={img.thumb}
              alt={img.alt}
              onClick={() => selectSlide(idx)}
              className={`object-cover cursor-pointer opacity-60 hover:opacity-100 rounded ${
                slideIndex === idx ? 'opacity-100 border-2 border-blue-500' : ''
              } w-16 h-16`}
            />
          ))}
        </div>

        {/* Main image */}
        <div className="relative w-full">
          <div className="relative">
            <img
              src={images[slideIndex].src}
              alt={images[slideIndex].alt}
              className="w-full rounded"
            />
          </div>

          {/* Prev Button */}
          <button
            onClick={() => nextSlide(-1)}
            className="absolute top-1/2 left-0 transform -translate-y-1/2 px-4 py-2 text-white text-xl font-bold hover:bg-black/70 transition rounded-r cursor-pointer"
          >
            ❮
          </button>

          {/* Next Button */}
          <button
            onClick={() => nextSlide(1)}
            className="absolute top-1/2 right-0 transform -translate-y-1/2 px-4 py-2 text-white text-xl font-bold hover:bg-black/70 transition rounded-l cursor-pointer"
          >
            ❯
          </button>
        </div>
      </div>
    </div>
  );
}
